const APP_BASE_URL = process.env.REACT_APP_APP_URL || "";

export function buildRegisterWithInviteUrl(code) {
  const normalized = String(code || "").trim();
  const base = `${APP_BASE_URL}/register`;
  if (!normalized) return base;
  return `${base}?invite=${encodeURIComponent(normalized)}`;
}

export function setPendingInviteCode(code) {
  return buildRegisterWithInviteUrl(code);
}

export function clearPendingInviteCode() {}

export function getPendingInviteCode() {
  return "";
}

export function redirectToRegisterWithInvite(code) {
  const nextUrl = buildRegisterWithInviteUrl(code);
  if (typeof window !== "undefined") {
    window.location.assign(nextUrl);
  }
  return nextUrl;
}

// Landing app does not auto-redeem invite after register.
export function usePostRegisterInvite() {}
